import { singleton, inject } from "tsyringe";

// shared
import HttpAdapterImpl from "@/shared/libs/http/HttpAdapter";

// entities
import type { RequestGetStudentStudyRecordList } from "@/entities/study/models/repository";
import type { ResponseGetStudentStudyRecordList } from "@/entities/study/models/dtos";
import { StudyRepository } from "@/entities/study/models/repository";

@singleton()
export default class StudyRepositoryImpl implements StudyRepository {
    constructor(
        @inject(HttpAdapterImpl)
        private readonly server: HttpAdapterImpl,
    ) {}

    public getStudentStudyRecordList = async (request: RequestGetStudentStudyRecordList) => {
        let url = `/v2/users/${request.studentId}/studies?include=summary`;

        if (request.size) {
            url += `&size=${request.size}`;
        }

        if (request.nextToken) {
            url += `&nextToken=${request.nextToken}`;
        }

        const response = await this.server.get<ResponseGetStudentStudyRecordList>(url);

        return response;
    };
}
